export type AppToUserLabel = {
    type: string;
    timeoutMs: number;
    sendingTime: string;
};

export interface IA2UNotificationData {
    title: string;
    body: string;
    mediaUrl: string;
    timeoutMs: number;
    recipientASID?: string | null;
    payload?: object;
    label: AppToUserLabel;
}

export enum A2UNotificationStatus {
    SENT = 'SENT',
    SCHEDULED = 'SCHEDULED',
    CANCELED = 'CANCELED',
}

export type A2UNotification = Omit<IA2UNotificationData, 'label'> & { type: string; allowDuplicates?: boolean };
